import { render, staticRenderFns } from "./PaxPriceCard.vue?vue&type=template&id=04cf2bd4&"
import script from "./PaxPriceCard.vue?vue&type=script&lang=js&"
export * from "./PaxPriceCard.vue?vue&type=script&lang=js&"
import style0 from "./PaxPriceCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports